import { PropsWithChildren } from 'react'

import { createGenericContext } from '@/Shared/ui/createGenericContext'
import { TransactionsRepository } from '@/Transactions/domain'
import { IUseTransactions, useTransactions } from '@/Transactions/ui/hooks'

type Context = {
  repository: TransactionsRepository
} & IUseTransactions

type Props = PropsWithChildren & {
  repository: TransactionsRepository
  itemsPerPage?: number
}

const [useTransaction, StateContextProvider] = createGenericContext<Context>()

const TransactionProvider = ({
  repository,
  itemsPerPage = 8,
  children,
}: Props): JSX.Element => {
  const controller = useTransactions(repository, itemsPerPage)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { TransactionProvider, useTransaction }
